<template>
  <div class="ids-404-not-found" style="height: 100%;">
    <div class="information">
      <p>没有找到该页面</p>
      <p>
        <span>404 Not Found</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iDS-404NotFound',
  mounted() {}
}
</script>

<style lang="scss">
.ids-404-not-found {
  .information {
    position: absolute;
    top: calc((100% - 9rem) / 2);
    left: calc((100% - 10rem) / 2);

    p {
      text-align: center;
      font-size: 1.5rem;

      span {
        color: gray;
      }
    }
  }
}
</style>
